<template>
  <div class="m-0" id="not-found">
    <div class="card block relative max-w-lg w-full mx-auto mt-12 p-8 text-center box-border">
      <h2 class="mt-20 mb-8 mx-0">{{ $t('NotFoundComponent.notFound') }}</h2>
      <i>
        <font-awesome-icon icon="fa-solid fa-ban" class="text-[var(--color-error)] text-[250px]"/>
      </i>
      <p  class="text-xl mt-2">{{ $t('NotFoundComponent.notFound') }}</p>
      <Button type="submit" @click.prevent="navigateToHome"
                class="mt-12 px-12 py-3 text-2xl text-white bg-[var(--color-orange)]
                hover:bg-[var(--color-fulvous)] mx-auto rounded-full disabled:opacity-20
                disabled:cursor-not-allowed transition duration-500" unstyled>
                {{ $t('NotFoundComponent.backToHome') }}
            </Button>
    </div>
  </div>
</template>

<script>
import { Button } from 'primevue';

export default {
  name: 'NotFoundComponent',
  components: { Button },
  methods: {
    navigateToHome() {
      this.$router.push('/');
    },
  },
};
</script>
